import { useGLTF } from "@react-three/drei";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import PointerShadow from "./PointerShadow.jsx";
import { MODELS } from "../loader/models.js";

const PointerWorkZone = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const { scene } = useGLTF(MODELS.POINTER_WORK_ZONE);

  return (
    <group position={position} rotation={rotation}>
      <PointerShadow width={4.9} height={2.4} opacity={0.6} softness={0.8} />
      <primitive scale={1.5} object={scene} position-y={-0.8} />
      <group position={[0, -0.5, 0]}>
        <RigidBody type="fixed" ccd={false}>
          <CuboidCollider args={[1.5, 0.2, 0.4]} />
        </RigidBody>
      </group>
    </group>
  );
};

export default PointerWorkZone;
